import React from "react";
import { useTranslation } from "react-i18next";

const ProofItem = ({ label, text }) => (
  <div className="proof-item">
    <div className="proof-title">{label}</div>
    <div className="proof-text">{text}</div>
  </div>
);

export default function ProofSection() {
  const { t } = useTranslation();
  const badges = t('proof.badges', { returnObjects: true });
  const kpis   = t('proof.kpis',   { returnObjects: true });

  return (
    <section id="proof" className="proof-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2>{t('proof.heading')}</h2>
          <p className="text-muted mb-0">{t('proof.description')}</p>
        </div>

        <div className="proof-grid">
          <div className="proof-card">
            <div className="proof-badges">
              {Array.isArray(badges) && badges.map((b, i) => (
                <span key={i} className="proof-badge">{b}</span>
              ))}
            </div>

            <div className="mt-2 mb-2 d-flex justify-content-center">
              <a
                rel="nofollow noopener noreferrer"
                href="https://www.exali.de/siegel/Alexander-Aprelkin"
                target="_blank"
                title={t('proof.insurance')}
              >
                <img
                  src="https://www.exali.de/siegel/siegel_de-2_1c3b2964baab89ed5848c513b9a0accb.png"
                  width="90" height="90"
                  alt={t('proof.insurance')}
                  loading="lazy"
                />
              </a>
            </div>

            <ProofItem label={t('proof.education.label')}     text={t('proof.education.text')} />
            <ProofItem label={t('proof.certifications.label')} text={t('proof.certifications.text')} />
            <ProofItem label={t('proof.value.label')}         text={t('proof.value.text')} />
          </div>

          <div className="proof-card">
            <div className="proof-kpis">
              {Array.isArray(kpis) && kpis.map((kpi, i) => (
                <div key={i} className="kpi">
                  <div className="kpi-v">{kpi.v}</div>
                  <div className="kpi-k">{kpi.k}</div>
                </div>
              ))}
            </div>
            <div className="proof-footer">
              <a href="#contact" className="offer-btn">{t('proof.cta')}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
